/**
 * Helper function to define an event
 */
export var defineEvent = function (def) { return def; };
